import { render, staticRenderFns } from "./ModalSeleccionarRemitos.vue?vue&type=template&id=6a552fc2"
import script from "./ModalSeleccionarRemitos.vue?vue&type=script&lang=js"
export * from "./ModalSeleccionarRemitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports